<template>
    <div>
        <div class="newRow">
            <div style="display:flex">
                <h4>Payment Schedule</h4>
            </div>
            <div style="padding-left: 10px;">
                <div class="row">
                    <div class="col-sm-3">
                        <base-input label="Contract Campaign Period" class="range-picker">
                            <el-date-picker
                                type="daterange"
                                placeholder="Campaign Date Range"
                                v-model="paymentScheduleForm.campaignPeriod"
                                class = "form-control"
                            >
                            </el-date-picker>
                        </base-input>
                        <!-- <base-input label="Contract Campaign Period">
                            <el-input value="01/08/2022 - 31/08/2022"
                                style="background-color: #f5f5f5;color: #685b51;" />
                        </base-input> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <base-input label="Total Media Amount">
                            <money-input :model="paymentScheduleForm.mediaTotal" v-model="paymentScheduleForm.mediaTotal" style="background-color: #f5f5f5;color: #685b51;"/>
                        </base-input>
                    </div>
                    <div class="col-sm-5">
                        <base-input label="Total Outstanding Media Amount">
                            <money-input :model="paymentScheduleForm.mediaOutstanding" v-model="paymentScheduleForm.mediaOutstanding" style="background-color: #f5f5f5;color: #685b51;" />
                        </base-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <base-input label="Total Production Amount">
                            <money-input  :model="paymentScheduleForm.productionTotal" v-model="paymentScheduleForm.productionTotal" style="background-color: #f5f5f5;color: #685b51;" />
                        </base-input>
                    </div>
                    <div class="col-sm-5">
                        <base-input label="Total Outstanding Production Amount">
                            <money-input :model="paymentScheduleForm.productionOutstanding" v-model="paymentScheduleForm.productionOutstanding" style="background-color: #f5f5f5;color: #685b51;" />
                        </base-input>
                    </div>
                </div>

                <div style="padding-top: 10px;padding-bottom: 5px;  border-bottom: solid 1px #e3e3e3;">
                    <el-button type="primary" @click="dialogType='new';dialogVisible=true;" :disabled="!isNew"> + Add Payment Schedule </el-button>
                    <!-- <label @click="addPaymentSchedule"><span class="add-button" style="background-color: #eb6100"> +
                    </span> Add Payment Schedule</label> -->
                </div>
                <el-table :data="paymentScheduleData">
                    <!-- <el-table-column type="No." label="No."  width="50"/> -->

                    <el-table-column width="70">
                        <template #default="prop">
                            <el-icon style="position:relative;top:3px;cursor:pointer" @click="dialogType='edit';dialogVisible=true;" ><Edit /></el-icon>
                            <el-icon style="position:relative;top:3px;cursor:pointer" @click="dialogType='view';dialogVisible=true;"><View /></el-icon>
                        </template>
                    </el-table-column>
                    <el-table-column label="PS No." prop="PSNo" width="100">

                    </el-table-column>
                    <el-table-column label="Description" prop="description" min-width="130" />
                    <el-table-column label="From" prop="CampaignPeriodStart" min-width="60" >
                        <template #default="prop" >
                            {{formatDate(prop.row.CampaignPeriodStart)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="To" prop="CampaignPeriodEnd" min-width="60" >
                        <template #default="prop" >
                            {{formatDate(prop.row.CampaignPeriodEnd)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="No. of Schedule" prop="NoOfSchedule" min-width="130" />
                    <el-table-column label="Schedule Media Amount" prop="ScheduleMediaAmount" min-width="150">
                        <template #default="prop" >
                            {{util.getMoneyFormat(prop.row.ScheduleMediaAmount)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Schedule Production Amount" prop="ScheduleProductionAmount" min-width="220" >
                        <template #default="prop" >
                            {{util.getMoneyFormat(prop.row.ScheduleProductionAmount)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Total Schedule Amount" prop="TotalScheduleAmount" min-width="150">
                        <template #default="prop" >
                            {{util.getMoneyFormat(prop.row.TotalScheduleAmount)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Paid Amount" prop="PaidAmount" min-width="70">

                    </el-table-column>
                    <el-table-column label="Has Invoice" min-width="70">

                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog
            v-model="dialogVisible"
            title="New Payment Schedule"
            width="95%"
            style="margin-top:7vh"
            :before-close="handleClose"
        >
            <NewPaymentSchedule :status="dialogVisible" :save="savePaymentSchedule" :type="dialogType"></NewPaymentSchedule>
            <template #footer>
                <span class="dialog-footer">
                    
                    <el-button type="primary" @click="savePaymentSchedule = true;dialogVisible = false;" v-if="dialogType!='view'">
                    OK
                    </el-button>
                    <el-button type="primary" @click="dialogType = 'edit';" v-if="dialogType=='view'">Edit</el-button>
                    <el-button @click="dialogVisible = false">Close</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
    import baseInput from "@/components/newUI/Inputs/BaseInput";
    import baseButton from "@/components/newUI/BaseButton";
    import baseRadio from "@/components/newUI/Inputs/BaseRadio";
    import moneyInput from "@/components/newUI/Inputs/MoneyInput"
    import NewPaymentSchedule from './NewPaymentSchedule';
    import { nextTick, ref,onMounted,reactive } from 'vue';
    const util = require('@/utilFunction');
    import { usePaymentScheduleStore } from '@/store/paymentSchedule';
    import {Edit,View} from '@element-plus/icons-vue';

    

    var newPaymentScheduleDialogShow = ref(false);
    var dialogVisible = ref(false);
    var savePaymentSchedule = ref(false);
    var paymentScheduleData = ref([]);
    var dialogType = ref('new');
    var isNew = ref(false);
    var paymentScheduleForm = reactive({campaignPeriod:[],mediaTotal:0,productionTotal:0,mediaOutstanding:0,productionOutstanding:0});
    var contractId = 59;


    function formatDate(date){
        return util.getDateFormat(date);
    }

    onMounted(() => {
        const paymentSchedule = usePaymentScheduleStore();
        util.loading();
        util.requestFromAWS(util.dev_endpoint,'getPaymentScheduleOptionList').then(val=>{
            console.log(val.data.data[0]);
            paymentSchedule.setInvoiceTerm(JSON.parse(val.data.data[0].InvoiceTerm));
            paymentSchedule.setPaymentTerm(JSON.parse(val.data.data[0].PaymentTerm));
            paymentSchedule.setPaymentType(JSON.parse(val.data.data[0].PaymentType));
        });
        util.requestFromAWSWithData(util.dev_endpoint,'getPaymentScheduleSummary',{"contractId":contractId}).then(val=>{
            if(val.data.data[0] && val.data.data[0].MediaTotal){
                isNew = true;
                paymentScheduleForm.campaignPeriod.push(val.data.data[0].CampaignStart)
                paymentScheduleForm.campaignPeriod.push(val.data.data[0].CampaignEnd)
                paymentScheduleForm.mediaTotal = val.data.data[0].MediaTotal;
                paymentScheduleForm.productionTotal = val.data.data[0].ProductionTotal;
                paymentScheduleForm.contractType = val.data.data[0].ContractType;
                paymentScheduleForm.contractId = contractId;
                paymentSchedule.setContractMedia(val.data.data[0].Media);
                paymentSchedule.setBusinessNature(val.data.data[0].BusinessNature);
                paymentSchedule.setAdditionalProduction(val.data.data[0].AdditionalProduction);
            }else{
                isNew = false;
                paymentScheduleData.value = JSON.parse(val.data.data[0].PaymentSchedule);
                paymentScheduleForm.campaignPeriod.push(val.data.data[0].CampaignPeriodStart)
                paymentScheduleForm.campaignPeriod.push(val.data.data[0].CampaignPeriodEnd)
                paymentScheduleForm.mediaTotal = val.data.data[0].TotalMediaAmount;
                paymentScheduleForm.productionTotal = val.data.data[0].TotalOutstandingProductionAmount;
                paymentScheduleForm.contractId = contractId;
                paymentSchedule.setContractMedia(val.data.data[0].Media);
                paymentSchedule.setBusinessNature(val.data.data[0].BusinessNature);
                paymentSchedule.setAdditionalProduction(val.data.data[0].AdditionalProduction);
                paymentSchedule.setPaymentScheduleData(paymentScheduleData.value);
            }
            util.closeLoading();
            paymentSchedule.setPaymentScheduleSummary(paymentScheduleForm);
        });
    })
    
</script>